export const isRequesterRoleRecord = (role) => {
  if (!role) {
    return false;
  }
  if (role.isRequesterRole === true || role.is_requester_role === true) {
    return true;
  }
  const code = String(role.roleCode || role.role_code || role.value || '').toUpperCase();
  return code === 'CUSTOMER';
};

/** @returns {boolean|null} null when not present in session */
export const getStoredUserIsRequester = () => {
  try {
    const raw = sessionStorage.getItem('userDetails');
    if (!raw) {
      return null;
    }
    const details = JSON.parse(raw);
    if (details.isRequesterRole === true || details.is_requester_role === true) {
      return true;
    }
    if (details.isRequesterRole === false || details.is_requester_role === false) {
      return false;
    }
  } catch {
    /* ignore */
  }
  return null;
};

export const isCurrentUserRequester = () => {
  const stored = getStoredUserIsRequester();
  if (stored === true) {
    return true;
  }
  if (stored === false) {
    return false;
  }
  try {
    const raw = sessionStorage.getItem('userDetails');
    if (raw) {
      const details = JSON.parse(raw);
      const code = String(details.roleCode || details.role_code || details.role || '').toUpperCase();
      if (code === 'CUSTOMER') {
        return true;
      }
    }
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/portal')) {
    return true;
  }
  return false;
};

/** Backward-compatible alias: requester portal UX, not the CUSTOMER platform role only. */
export const isCustomer = (role) => {
  if (typeof role === 'string') {
    const normalized = role.toLowerCase();
    return normalized === 'customer' || normalized === 'end-user' || normalized === 'enduser';
  }
  return isRequesterRoleRecord(role);
};

export const isAgent = (role) => (role || '').toLowerCase() === 'agent';
export const isTeamLead = (role) => {
  const r = (role || '').toLowerCase();
  return r === 'team_lead' || r === 'team-lead' || r === 'team lead';
};
export const isAdmin = (role) => (role || '').toLowerCase() === 'admin';
